module.exports = __webpack_public_path__ + "images/psp/PSPHero/motorcycle-hero.webp";